/* eslint-disable array-callback-return */

'use strict';

var shippingAddressUpdate = require('./shippingAddressUpdate');
var $shipping = $('.shipping-content');
var $cvsStore = $('.cvs-store');
var storeAddress = {
    address1: $cvsStore.data('cvsStoreName'),
    address2: $cvsStore.data('cvsStoreAddress1'),
    taiwan: '台灣',
    zipCode: '826'
};

/**
 * Show or hides the shipping methods based on selection
 */
var displayShippingMethod = function () {
    var $shippingTypeRegular = $('.shipping-type-regular');
    var $shippingTypeCvs = $('.shipping-type-cvs');
    $shippingTypeRegular.find('input[data-shippingtype="cvs"]').parent().remove();
    $shippingTypeCvs.find('input[data-shippingtype="regular"]').parent().remove();
    $shippingTypeCvs.find('input[data-shippingtype="access-point"]').parent().remove();
};

/**
 * Enable phone validation if using CVS Store Method
 */
var enablePhoneValidation = function () {
    var phoneRegex = $('input[data-phone-regex]').data('phone-regex');
    $('.shipping-address, .billing-address').find('input[type=tel]').attr('pattern', phoneRegex);
};

/**
 * Disable phone validation if NOT using CVS method
 */
var disablePhoneValidation = function () {
    $('.shipping-address, .billing-address').find('input[type=tel]').removeAttr('pattern');
};

/**
 * Check if CVS method is selected
 * @returns {boolean} is shipping method selected
 */
var isCVSShippingSelected = function () {
    return $('.shipping-method-list').find('[data-shippingtype="cvs"]:checked').length > 0;
};

/**
 * Show error if CVS shipping method is not selected
 */
var cvsShippingMethodNotSelected = function () {
    $('.js-cvs-store-cta').find('.invalid-feedback').show();
};

/**
 * Update shipping form when CVS store data is returned
 */
var updateShippingFormWithStoreAddress = function () {
    if (storeAddress.address1) {
        $('.shippingAddressOne').val(storeAddress.address1);
    }

    if (storeAddress.address2) {
        $('.shippingAddressTwo').val(storeAddress.address2);
    }

    if ($('#shippingState option[value=' + storeAddress.taiwan + ']').length <= 0) {
        $('#shippingState').append('<option id=' + storeAddress.taiwan + ' value=' + storeAddress.taiwan + '>' + storeAddress.taiwan + '</option>');
    }

    if ($('#shippingAddressCity option[value=' + storeAddress.taiwan + ']').length <= 0) {
        $('#shippingAddressCity').append('<option id=' + storeAddress.taiwan + ' value=' + storeAddress.taiwan + '>' + storeAddress.taiwan + '</option>');
    }

    if ($('#shippingZipCode option[value=' + storeAddress.zipCode + ']').length <= 0) {
        $('#shippingZipCode').append('<option id=' + storeAddress.zipCode + ' value=' + storeAddress.zipCode + '>' + storeAddress.zipCode + '</option>');
    }

    $('#shippingState option[value=' + storeAddress.taiwan + ']').prop('selected', true);
    $('#shippingAddressCity option[value=' + storeAddress.taiwan + ']').prop('selected', true);
    $('#shippingZipCode option[value=' + storeAddress.zipCode + ']').prop('selected', true);
};

var updateBillingFormWithStoreAddress = function () {
    if ($('.js-cvs-store-wrapper').length && $('.cvs-store-selected').val() !== '') {
        if ($('#billingstateCode option[value=' + storeAddress.taiwan + ']').length <= 0) {
            $('#billingstateCode').append('<option id=' + storeAddress.taiwan + ' value=' + storeAddress.taiwan + '>' + storeAddress.taiwan + '</option>');
            $('#billingstateCode option[value=' + storeAddress.taiwan + ']').prop('selected', true);
        }

        if ($('#billingcity option[value=' + storeAddress.taiwan + ']').length <= 0) {
            $('#billingcity').append('<option id=' + storeAddress.taiwan + ' value=' + storeAddress.taiwan + '>' + storeAddress.taiwan + '</option>');
            $('#billingcity option[value=' + storeAddress.taiwan + ']').prop('selected', true);
        }

        if ($('#billingpostalCode option[value=' + storeAddress.zipCode + ']').length <= 0) {
            $('#billingpostalCode').append('<option id=' + storeAddress.zipCode + ' value=' + storeAddress.zipCode + '>' + storeAddress.zipCode + '</option>');
            $('#billingpostalCode option[value=' + storeAddress.zipCode + ']').prop('selected', true);
        }

        $('#billingstateCode option[value=' + storeAddress.taiwan + ']').prop('selected', true);
        $('#billingcity option[value=' + storeAddress.taiwan + ']').prop('selected', true);
        $('#billingpostalCode option[value=' + storeAddress.zipCode + ']').prop('selected', true);
    }
};

/**
 * Returning from store or store data available
 */
var returningFromStore = function () {
    var cvsStoreID = $('.cvs-store').data('cvsStoreId');
    shippingAddressUpdate.selectShippingType('cvs');
    updateShippingFormWithStoreAddress();
    $('.submit-shipping').removeClass('d-none');
    $('.cvs-store-selected').val(cvsStoreID);
};

/**
 * Redirect customer to CVS Store selection page
 * @param {string} saveData - URL for route to save customer data
 * @param {string} redirect - URL to send customer to CVS store selection page
 */
var redirectToECPay = function (saveData, redirect) {
    var shippingFormData = $('.single-shipping .shipping-form').serialize();
    $.ajax({
        url: saveData,
        type: 'POST',
        data: shippingFormData,
        success: function () {
            window.location.replace(redirect);
        }
    });
};

/**
 * Add event listeners
 */
var addEventListeners = function () {
    $('#cvs-store-redirect').on('click', function (e) {
        e.preventDefault();
        $('.js-cvs-store-cta').find('.invalid-feedback').hide();
        if (isCVSShippingSelected()) {
            var url = $(this).attr('data-url');
            var saveDataUrl = $(this).attr('data-url-save-addr');
            redirectToECPay(saveDataUrl, url);
        } else {
            cvsShippingMethodNotSelected();
        }
    });
};

module.exports = {

    methods: {
        displayShippingMethod: displayShippingMethod
    },

    updateBillingFormWithStoreAddress: updateBillingFormWithStoreAddress,

    initConvenienceStore: function () {
        // Check if returning from convenience store selection
        var returningFromStoreSelect = $('#shipping-type-selector-cvs').data('returning');
        if (returningFromStoreSelect) {
            // Returning from selecting a convenience store, load CVS form
            returningFromStore();
        } else {
            // Load normal shipping form
            shippingAddressUpdate.isShippingRegular();
        }
        shippingAddressUpdate.addEventListeners();
        disablePhoneValidation();
        addEventListeners();
        $shipping.on('click', '#shipping-type-selector-cvs', function (e) {
            e.stopImmediatePropagation();
            shippingAddressUpdate.clearForm();
            enablePhoneValidation();
            shippingAddressUpdate.selectShippingType('cvs');

            if (returningFromStoreSelect) {
                returningFromStore();
            }
        });
    }
};
